// Mobile nav toggle — expands the primary nav on small screens.

export default function navToggle() {
    const btn = document.querySelector("[data-nav-toggle]");
    if (!btn) return;

    const nav = btn.closest(".gg-nav");
    if (!nav) return;

    btn.addEventListener("click", () => {
        const expanded = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", String(!expanded));
        nav.classList.toggle("is-open");
    });

    // Close when a nav link is clicked
    nav.addEventListener("click", (event) => {
        if (event.target.tagName === "A") {
            btn.setAttribute("aria-expanded", "false");
            nav.classList.remove("is-open");
        }
    });
}
